/**
 * 重定向类型枚举
 */
export enum E_RedirectType {
    MFA_AUTH = 'mfa_auth' // MFA认证
    // 后续可以添加更多类型
}

/**
 * 重定向数据接口
 */
export interface IRedirectData {
    type: E_RedirectType
    mfaUrl?: string // MFA认证URL
    reason?: string // 重定向原因
}